<template>
  <vs-table hover-flat v-if="messages && messages.length" :data="messages">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('send_agent')"></vs-th>
      <vs-th v-text="$t('date')"></vs-th>
      <vs-th v-text="$t('time')"></vs-th>
      <vs-th v-text="$t('title')"></vs-th>
      <vs-th v-text="$t('content')"></vs-th>
      <vs-th v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.send_agent" :data-tr-title="$t('send_agent')"></vs-td>
        <vs-td v-text="tr.date" :data-tr-title="$t('date')"></vs-td>
        <vs-td v-text="tr.time" :data-tr-title="$t('time')"></vs-td>
        <vs-td v-text="tr.title" :data-tr-title="$t('title')"></vs-td>
        <vs-td v-text="tr.content" :data-tr-title="$t('content')"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <delete-button @click="$emit('customClickDelete', key, tr.id)"></delete-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.MessageManagement.List',
  props: {
    messages: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
